var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "prelative" }, [
    _c(
      "fieldset",
      { staticClass: "py-2", attrs: { id: "companysearch-fieldset" } },
      [
        _c("legend", [
          _vm._v(_vm._s(_vm.$l10n.__("Chercher dans l'annuaire des sociétés")))
        ]),
        _vm._v(" "),
        _c("template-form", {
          attrs: {
            context: _vm.context,
            thirdName: _vm.thirdName,
            district: _vm.district,
            searching: _vm.searching
          },
          on: {
            companies: _vm.companiesFetched,
            submit: _vm.searchCompanies,
            countryCodeSelected: _vm.countryCodeSelected
          }
        }),
        _vm._v(" "),
        _vm.companiesResult
          ? _c(
              "div",
              {
                staticClass: "prelative",
                attrs: { id: "companysearch-result" }
              },
              [
                _c("div", { staticClass: "resultInfos" }, [
                  _c("span", { staticClass: "nb_results ml-2" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$l10n.n__(
                            "%(nb)s société trouvée",
                            "%(nb)s sociétés trouvées",
                            _vm.companiesResult.length,
                            { nb: _vm.companiesResult.length }
                          )
                        ) +
                        "\n                "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "resultList row gutters1 mxh-320 ovy-auto" },
                  [
                    _c(_vm.countryCode + "_results", {
                      tag: "component",
                      attrs: {
                        countryCode: _vm.countryCode,
                        companies: _vm.companiesResult
                      },
                      on: { companySelected: _vm.fillThird }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }